import React, { createContext, useState } from "react";
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";

import "./root-component.css";
import { NavigationConfig } from "./components/NavMenu";
import NavigationBar from "./components/NavigationBar";
import { BrowserRouter } from "react-router-dom";
import toNavigations from "./configuration/toNavigations";

export const ThemeContext = createContext(createTheme());

export const NavbarDrawerContext = createContext({
  drawerState: false,
  setDrawerState: (newState: boolean) => {},
});

const App = function (props) {
  const applicationConfigurations = props.getActiveApplications();

  const [navigations, setNavigations] = useState<NavigationConfig[]>(
    toNavigations(applicationConfigurations)
  );

  if (props.subscribeToAppActivation) {
    props.subscribeToAppActivation(() => {
      setNavigationConfiguration(props.getActiveApplications());
    });
  }

  function setNavigationConfiguration(applicationConfigurations) {
    const navigations: NavigationConfig[] = toNavigations(
      applicationConfigurations
    );
    setNavigations(navigations);
  }

  const [drawerState, setDrawerState] = useState<boolean>(false);
  return (
    <ThemeProvider theme={props.theme}>
      <CssBaseline />
      <BrowserRouter>
        <ThemeContext.Provider value={props.theme}>
          <NavbarDrawerContext.Provider
            value={{
              drawerState,
              setDrawerState: (newState) => {
                setDrawerState(newState);
              },
            }}
          >
            <NavigationBar navigations={navigations} />
          </NavbarDrawerContext.Provider>
        </ThemeContext.Provider>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
